import { useState, useEffect } from "react";
import Landing from "./components/Landing";
import Login from "./components/Login";
import LexSovereign from "./components/LexSovereign";
import api from "./services/api";
import "./App.css";

function App() {
  const [page, setPage] = useState("landing");
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      const saved = sessionStorage.getItem('lexsovereign_session');
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          if (parsed.token) {
            const verified = await api.verifySession(parsed.token);
            setSession({ ...parsed, ...verified });
            setPage("app");
          }
        } catch {
          sessionStorage.removeItem('lexsovereign_session');
        }
      }
      setLoading(false);
    };
    checkSession();
  }, []);

  const handleLogin = (sessionData) => {
    setSession(sessionData);
    setPage("app");
  };

  const handleLogout = () => {
    sessionStorage.removeItem('lexsovereign_session');
    setSession(null);
    setPage("landing");
  };

  if (loading) {
    return (
      <div style={{ height: "100vh", background: "#05070A", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ color: "#D4AF37", fontSize: 14, fontFamily: "'Outfit', sans-serif", letterSpacing: "0.15em" }}>
          Cargando...
        </div>
      </div>
    );
  }

  if (page === "landing" && !session) {
    return <Landing onAccess={() => setPage("login")} />;
  }

  if (page === "login" && !session) {
    return <Login onLogin={handleLogin} onBack={() => setPage("landing")} />;
  }

  return <LexSovereign session={session} onLogout={handleLogout} />;
}

export default App;
